import React from 'react';
import PropTypes from 'prop-types';
import css from './Time.css';
import Title from 'common/Title';

function fullName(participant) {
  return participant.firstName + ' ' + participant.lastName;
}

function participantsList(participants) {
  return(
    <div className={css['text']}>
      {participants.map(participant => <div key={participant.id}>{fullName(participant)}</div>)}
    </div>);
}

// A list of participants in a group session.
export default function GroupSessionParticipants({participants}) {
  if (!participants || participants.length === 0) {
    return <section/>;
  }
  return (
    <div className={css["main"]}>
      <Title text="Group Session Attendees"/>
      {participantsList(participants)}
    </div>);
}

GroupSessionParticipants.propTypes = {
  participants: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired
  }))
};
